/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Aspect_Ratio_LabelInputs */



/**
* | output |
* | --- |
* | "Aspect Ratio" |
*
* @param {New_Project_Aspect_Ratio_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_aspect_ratio_label = /** @type {((inputs?: New_Project_Aspect_Ratio_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Aspect_Ratio_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ratio d'image")
	if (locale === "de") return /** @type {LocalizedString} */ ("Seitenverhältnis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proporzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Соотношение сторон")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relación de aspecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("长宽比")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アスペクト比")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आस्पेक्ट अनुपात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Proporção da tela")
	return /** @type {LocalizedString} */ ("Aspect Ratio")
});